import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/features/auth/auth-store";
import { getProgress } from "@/features/learn/progress-store";
import { getTotalLessonCount } from "@/features/learn/content";
import { CompletionCertificate } from "@/features/learn/components/CompletionCertificate";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Certificate = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const lang = i18n.language.split("-")[0];
  const username = useAuthStore((s) => s.user?.username) ?? "Player";

  const progress = getProgress();
  const completedCount = Object.values(progress).filter((p) => p.completed).length;
  const totalCount = getTotalLessonCount();
  const allCompleted = completedCount >= totalCount;

  // Find the latest completedAt date
  const sortedCompletions = Object.values(progress)
    .filter((p) => p.completedAt)
    .sort((a, b) => new Date(b.completedAt!).getTime() - new Date(a.completedAt!).getTime());
  const latestCompletedAt = sortedCompletions[0]?.completedAt ?? new Date().toISOString();

  if (!allCompleted) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center space-y-4">
        <p className="text-lg font-semibold">
          {lang === "es"
            ? "Aun no has completado todas las lecciones"
            : "You haven't completed all lessons yet"}
        </p>
        <p className="text-sm text-muted-foreground">
          {lang === "es"
            ? `${completedCount} de ${totalCount} lecciones completadas`
            : `${completedCount} of ${totalCount} lessons completed`}
        </p>
        <Button variant="outline" onClick={() => navigate("/learn")}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          {lang === "es" ? "Ir a la Academia" : "Go to Academy"}
        </Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <CompletionCertificate
        username={username}
        completedAt={latestCompletedAt}
        totalLessons={totalCount}
        onClose={() => navigate("/profile")}
      />
    </div>
  );
};

export default Certificate;
